export enum BroadcastIds {
  CHANNEL = 'vs-channel-oidc-client',
  MESSAGE = 'vs-message-oidc-client',
}

export type MessagePayload = {
  id: BroadcastIds.MESSAGE;
  payload: {
    sessionUUID: string;
    client_id: string;
    authority: string;
    isLogout: boolean;
  };
};
